export const getValueKeys = () => ['value', 'min', 'max'] as const;
